// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4n-1";
export var standaloneTable = "_4n-0";